<div class="snackbar-inner-container">
  <mat-icon>info</mat-icon>
  <span matSnackBarLabel class="snackbar-label">
    {{ data.message }}
  </span>
  <button matSnackBarAction class="snackbar-action" (click)="dismiss()">
    <span class="cdk-visually-hidden">Close</span>
    <mat-icon svgIcon="close" aria-hidden="false" class="ord-icon"></mat-icon>
  </button>
  <mat-progress-bar
    mode="determinate"
    [value]="progress"
    class="snackbar-progress-bar"
  ></mat-progress-bar>
</div>
